import axios from "axios";
import { BASE_URL_SERVICE } from "../constants";

export class DocumentosService {
    
    static uploadExcel = async ( {usuario_id, archivo} ) => {

      try {
        let formData = new FormData();

        formData.append("usuario_id", `${usuario_id}`);
        formData.append("archivo", archivo);

        const response = await axios({
          method: "post",
          url: BASE_URL_SERVICE + "/alumno/documentos_upload_excel",
          data: formData,
          headers: {
             'Content-Type': 'multipart/form-data',
            //  'Authorization': "Bearer eyJ0eciOiJSUzI1NiJ9.eyJMiIsInNjb3BlcyI6W119.K3lW1STQhMdxfAxn00E4WWFA3uN3iIA",
          },
        });

        return response.data;
      } catch (error) {
          return undefined;
      }

    }
    
    static conversacionCambiarEstado = async ( {usuario_id, origen, origen_id, estado} ) => {

      try {
        let formData = new FormData();

        formData.append("usuario_id", `${usuario_id}`);
        formData.append("origen", `${origen}`);
        formData.append("origen_id", `${origen_id}`);
        formData.append("estado", `${estado}`);

        const response = await axios({
          method: "post",
          url: BASE_URL_SERVICE + "/alumno/conversacion_cambiar_estado",
          data: formData,
          headers: {
            //  'Content-Type': 'multipart/form-data',
            //  'Authorization': "Bearer eyJ0eciOiJSUzI1NiJ9.eyJMiIsInNjb3BlcyI6W119.K3lW1STQhMdxfAxn00E4WWFA3uN3iIA",
          },
        });

        return response.data;
      } catch (error) {
          return undefined;
      }

    }
}